import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { OrderService } from "../../../services/order-service";
import { DataGrid } from "@material-ui/data-grid";
import { Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import AuthContext from "../../../context/auth-context";

export const Recentorder = () => {
  const ctx = useContext(AuthContext);

  const format2 = "YYYY-MM-DD";

  const [orders, setOrderDetails] = useState([]);

  const [orderID, setorderID] = useState();

  const history = useHistory();

  const [state, setState] = useState(false);

  const [submitloading, setSubmitLoading] = useState(true);

  const handleShow4 = (e) => {
    setState({ show4: true });
    setorderID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const resentorderSearch = async () => {
    try {
      const result = await OrderService.resentorderDetails();
      let orderArray = [];
      const finalOrders = result.results.map((item) => {
        if(item.payment_method == "PAYHERE" && item.payment_status == "APPROVED"){
          orderArray.push(item)
        }

        if(item.payment_method == "CASH_ON_DELIVERY"){
          orderArray.push(item)
        }
        
      });
      setOrderDetails(orderArray);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await OrderService.orderDelete(orderID);

      setSubmitLoading(true);
      notify("Success Delete Order");
      handleClose();
      resentorderSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  useEffect(() => {
    resentorderSearch();
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "Order Id",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>#{params.row.id} - {params.row.user.name} </div>;
      },
    },
    {
      field: "total",
      headerName: "Price(Rs.)",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "payment_method",
      headerName: "Payment Method",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_method === "CASH_ON_DELIVERY") {
          return (
            <div>
              {" "}
              <span>COD</span>
            </div>
          );
        } else if(params.row.payment_method === "PAYHERE") {
          return (
            <div>
              {" "}
              <span>PH</span>
            </div>
          );
        }else{
          return (
            <div>
              {" "}
              <span>BD</span>
            </div>
          );
        }
      }
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_status === "PENDING") {
          return (
            <div>
              {" "}
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.payment_status === "APPROVED") {
          return (
            <div>
              {" "}
              <span className="badge badge-success">APPROVED</span>
            </div>
          );
        } else if (params.row.payment_status === "CANCELED") {
          return (
            <div>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        } else if (params.row.payment_status === "FAILED") {
          return (
            <div>
              <span className="badge badge-primary">FAILED</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-dark">CHANGEBACK</span>
            </div>
          );
        }
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.status === "PENDING") {
          return (
            <div>
              {" "}
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.status === "PREPARING") {
          return (
            <div>
              <span className="badge badge-light">PREPARING</span>
            </div>
          );
        } else if (params.row.status === "DELIVERING") {
          return (
            <div>
              <span className="badge badge-secondary">DELIVERING</span>
            </div>
          );
        } else if (params.row.status === "COMPLETED") {
          return (
            <div>
              <span className="badge badge-success">COMPLETED</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/edit-order/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-11">
                      <h6> Recently Placed Orders</h6>
                    </div>
                    <div>
                      <Modal
                        show={state.show4}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            Confirm Deletion
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <h6 style={{ color: "red" }}>
                            Are you sure you want to remove this item ?
                          </h6>
                        </div>
                        <Modal.Footer>
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            style={{ backgroundColor: "red" }}
                            onClick={onDelete}
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div style={{ minHeight: 650, height: 650, flex: "100%", overflow: "scroll" }}>
                    <DataGrid
                      rows={orders}
                      disableExtendRowFullWidth={false}
                      columns={columns}
                      autoHeight
                      hideFooter
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recentorder;
